import React, { useEffect, useState } from 'react'
import './Admin.css'
import AdminSidebar from './comon/AdminSidebar'
import Header from './comon/Header'
import { Button, Card, CardBody, CardHeader } from 'reactstrap'
import {
    CircularProgress,
    Alert,
    Box,
    Typography
} from '@mui/material';
import {
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

import { } from 'react-icons/md'
import { FaBell } from 'react-icons/fa'

function PendingUserList() {
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const sendReminder = (email, name) => {
        setLoading(true);
        setSuccess(false);

        fetch('https://nuggettrap.com/api/ekyc/send-reminder.php?email=' + email + '&fname=' + name, {
            method: 'POST'
        })
            .then((res) => res.json())
            .then((result) => {
                ///setUserList(result.result)
                // alert('email send successfully')
                setLoading(false);
                setSuccess(true);
            })
    }

    useEffect(() => {
        fetch('https://nuggettrap.com/api/ekyc/get-pending-users.php', {
            method: 'POST'
        })
            .then((res) => res.json())
            .then((result) => {
                setUserList(result.result)
            })
    }, [])
    return (
        <div className='main-div'>
            <AdminSidebar />
            <div className='fill-width'>
                <Header />

                <div style={{ display: 'block' }}>

                    <Card>
                        <CardHeader>
                            <h3> Pending request list</h3>
                        </CardHeader>
                        <CardBody>
                            {success && (
                                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                                    <Alert severity="success">✅ Message sent successfully!</Alert>
                                </Box>
                            )}
                            {loading && (
                                <Box
                                    sx={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        zIndex: 9999
                                    }}
                                >
                                    <CircularProgress />
                                </Box>
                            )}

                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                                        <TableRow>
                                            <TableCell><b>Id</b></TableCell>
                                            <TableCell><b>Full Name</b></TableCell>
                                            <TableCell><b>Email</b></TableCell>
                                            <TableCell><b>Contact</b></TableCell>
                                            <TableCell><b>Action</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {userList.map((user, i) => (
                                            <TableRow key={user.id}>
                                                <TableCell>{i+1}</TableCell>
                                                <TableCell>{user.fname}</TableCell>
                                                <TableCell>{user.email}</TableCell>
                                                <TableCell>{user.phone}</TableCell>
                                                <TableCell>
                                                    <Button
                                                        variant="contained"
                                                        color="warning"
                                                        size="small"
                                                        startIcon={<NotificationsActiveIcon />}
                                                        onClick={() => { sendReminder(user.email, user.fname) }}
                                                    >
                                                        Send reminder
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* <Table>
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Full Name</th>
                                        <th>Email </th>
                                        <th>Contact</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userList.length > 0 &&
                                        <>
                                            {userList.map((user, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1} </td>
                                                    <td>{user.fname} </td>
                                                    <td>{user.email} </td>
                                                    <td>{user.phone} </td>
                                                    <td>
                                                        <Button color='warning'
                                                            onClick={() => { sendReminder(user.email, user.fname) }}>
                                                            <FaBell />
                                                            Send reminder
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    }
                                </tbody>
                            </Table> */}
                        </CardBody>
                    </Card>
                </div>
            </div>

        </div>
    )
}

export default PendingUserList